var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1739.000000, -126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1728.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.000000, 79.267749)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.9375,
    y1: 9.1875,
    x2: 3.9375,
    y2: 13.5625,
    stroke: "#515151",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.0625,
    y1: 9.1875,
    x2: 10.0625,
    y2: 13.5625,
    stroke: "#515151",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0 C13.5522847,0 14,0.44771525 14,1 L14,8.625 C14,9.17728475 13.5522847,9.625 13,9.625 L1,9.625 C0.44771525,9.625 0,9.17728475 0,8.625 L0,1 C0,0.44771525 0.44771525,0 1,0 L13,0 Z M13,1 L1,1 L1,8.625 L13,8.625 L13,1 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "7.875 1.74936657 8.58210678 2.45647335 6.639 4.398 9.08210678 4.39823581 5.43323754 8.04710505 4.72613076 7.33999827 6.667 5.398 4.22613076 5.39823581"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/electric.dfdb6f4fdcf3a8db222e4f12ef051132.svg";
export { ForwardRef as ReactComponent };